import { OfferDetailsPageContent } from "@app/offers/pages";
import { offerAtom } from "@core/offers/atoms";
import { getOfferService } from "@core/offers/services";
import { publicRoutes } from "@framework/middleware";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { userAtom } from "../../../config/atoms";
import { getRootSettings, pageHead } from "../../../config/drivers";

export const loader = publicRoutes(async ({ params, http, success }) => {
  const { id } = params;

  const response = await getOfferService(http, id!);

  return success(response);
});

export default function OfferDetailsPage() {
  const {
    offer,
    completeProfileFirst,
    message,
    profileVerificationPending,
    user,
  } = useLoaderData<typeof loader>();

  if (user) {
    userAtom.update(user);
  }

  if (offer) {
    offerAtom.update(offer);

    return <OfferDetailsPageContent />;
  }

  if (completeProfileFirst) {
    // Handle complete profile first case
    return null;
  }

  if (profileVerificationPending) {
    // Handle profile verification pending case
    return null;
  }
}

export const meta: MetaFunction<typeof loader> = ({ data, matches }) => {
  const settings = getRootSettings(matches);

  return pageHead({
    title: data?.offer?.name || "",
    appendAppName: true,
    image: data?.offer?.image?.url || "",
    settings,
  });
};
